module.exports = __webpack_public_path__ + "static/android-chrome-512x512-54b136e08df6ddc13a3ad35582b4af6a.png";